const state = {
    sortSettings: null,
};

const mutations = {
    SET_SORT_SETTINGS: (state, info) => {
        state.sortSettings = { ...info };
    },
    UPDATE_SORT_SETTINGS: (state, info) => {
        state.sortSettings = { ...state.sortSettings, ...info };
        console.log("sortSettings", state.sortSettings);
    },
};

const actions = {
    setSortSettings({ commit }, info) {
        commit("SET_SORT_SETTINGS", info);
    },
    updateSortSettings({ commit }, info) {
        commit("UPDATE_SORT_SETTINGS", info);
    }
};

export default {
    namespaced: true,
    state,
    mutations,
    actions
};



// WEBPACK FOOTER //
// ./src/vuex/modules/user_settings.js